import { Component, Input } from "@angular/core";
import { Estudo } from "../estudo/estudo";

@Component({
  selector: "estudo-cabecalho",
  templateUrl: "./estudo-cabecalho.component.html"
})
export class EstudoCabecalhoComponent {
  @Input() estudo: Estudo;
  @Input() mostrarResumo: boolean = true;
  @Input() mostrarComparar: boolean = true;
  @Input() mostrarVisualizar: boolean = true;
  @Input() mostrarObservacao: boolean = true;
  @Input() mostrarEmail: boolean = true;
  @Input() mostrarRenovacao: boolean = true;

  constructor() {}
}
